/**
 * The travel control filter (plan R17, §2.10): runs on the player's control every tick, after `readPlayerControl`
 * (M3 plan §2.5). While charging, cruising, riding a lane or interdicted, W/S (or the left stick) move the persistent
 * cruise throttle within [`minThrottle`, 1], and translation, boost and both fire buttons are zeroed; pitch, yaw and
 * roll pass through (the detached turn scales them). In a relay transit everything is zeroed. Allocation-free.
 */
import { SIM_DT } from '../../core/loop'
import type { PlayerControl } from '../../input/playerInput'
import type { ReachCore } from '../../reach/runtime/types'
import type { TravelRuntime } from './state'

export function travelControlFilter(rt: TravelRuntime, core: ReachCore, c: PlayerControl): void {
  const t = core.travel
  const mode = t.mode
  if (mode === 'normal') return
  c.surge = 0
  c.sway = 0
  c.heave = 0
  c.boost = false
  c.firePrimary = false
  c.fireSecondary = false
  if (mode === 'transit') {
    c.pitch = 0
    c.yaw = 0
    c.roll = 0
    return
  }
  const cr = rt.configs.travel.cruise
  const th = t.throttle + core.input.throttleAxis * cr.throttleRate * SIM_DT
  t.throttle = th < cr.minThrottle ? cr.minThrottle : th > 1 ? 1 : th
}
